module.exports = __webpack_public_path__ + "static/media/no_sound.a180b734.png";